import Button from '@atlaskit/button/standard-button';
import { Link } from '@atlassian/amkt-common';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_LISTING, ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS } from '../../../analytics/Events';
import { FooterContainer } from './AppRequestDialogModal.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AppRequestDialogFooter = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const handleViewAppDetailsClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS,
      objectType: ANALYTICS_OBJECT_TYPE_APP_LISTING,
      objectId: props.appKey
    });
    window.open(props.links.appDetails.expand({
      appKey: props.appKey
    }));
  };
  return /*#__PURE__*/_jsxs(FooterContainer, {
    children: [/*#__PURE__*/_jsx(Link, {
      onClick: handleViewAppDetailsClick,
      children: "View app details"
    }), /*#__PURE__*/_jsx(Button, {
      appearance: "primary",
      onClick: props.onClose,
      children: "Got it"
    })]
  });
};